// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"301":"a58405c3","978":"a58405c3"}[chunkId] + ".css";
};